import { render, staticRenderFns } from "./ResumenIa.vue?vue&type=template&id=18e1001c&lang=pug&"
import script from "./ResumenIa.vue?vue&type=script&lang=js&"
export * from "./ResumenIa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../build/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports